import { countVars } from "../WabaTemplateModal/helpers";

// Arma los components[] en el formato que Meta espera al CREAR una plantilla (0368 C6),
// incluyendo los `example` obligatorios por cada variable {{n}}. Header solo TEXTO
// (el header con media requiere resumable upload + handle, fuera de este alcance).

export const NAME_RE = /^[a-z0-9_]+$/;

export function buildComponents(form) {
  const components = [];

  if (form.headerType === "TEXT" && form.headerText.trim()) {
    const comp = { type: "HEADER", format: "TEXT", text: form.headerText };
    const n = countVars(form.headerText);
    if (n > 0) comp.example = { header_text: form.headerExamples.slice(0, n) };
    components.push(comp);
  } else if (form.headerType === "IMAGE" && form.headerHandle) {
    components.push({
      type: "HEADER",
      format: "IMAGE",
      example: { header_handle: [form.headerHandle] },
    });
  }

  if (form.body.trim()) {
    const comp = { type: "BODY", text: form.body };
    const n = countVars(form.body);
    if (n > 0) comp.example = { body_text: [form.bodyExamples.slice(0, n)] };
    components.push(comp);
  }

  if (form.footer.trim()) {
    components.push({ type: "FOOTER", text: form.footer });
  }

  const validButtons = (form.buttons || []).filter((b) => b.text.trim());
  if (validButtons.length) {
    components.push({
      type: "BUTTONS",
      buttons: validButtons.map((b) => {
        if (b.type === "URL") return { type: "URL", text: b.text, url: b.url };
        if (b.type === "PHONE_NUMBER")
          return { type: "PHONE_NUMBER", text: b.text, phone_number: b.phone };
        return { type: "QUICK_REPLY", text: b.text };
      }),
    });
  }

  return components;
}

// Valida el formulario contra las reglas de Meta (0368 §3). Devuelve el primer error o null.
export function validateForm(form) {
  if (!form.whatsappId) return "Selecciona la conexión WABA.";
  if (!form.name.trim()) return "El nombre es obligatorio.";
  if (!NAME_RE.test(form.name)) return "El nombre solo admite minúsculas, números y guiones bajos.";
  if (!form.category) return "Selecciona una categoría.";
  if (!form.language) return "Selecciona un idioma.";
  if (!form.body.trim()) return "El cuerpo (BODY) es obligatorio.";

  if (form.headerType === "IMAGE" && !form.headerHandle) {
    return "Sube la imagen del encabezado.";
  }
  const headerVars = form.headerType === "TEXT" ? countVars(form.headerText) : 0;
  for (let i = 0; i < headerVars; i++) {
    if (!form.headerExamples[i]?.trim()) return `Falta el ejemplo de la variable {{${i + 1}}} del encabezado.`;
  }
  const bodyVars = countVars(form.body);
  for (let i = 0; i < bodyVars; i++) {
    if (!form.bodyExamples[i]?.trim()) return `Falta el ejemplo de la variable {{${i + 1}}} del cuerpo.`;
  }

  for (const b of form.buttons || []) {
    if (!b.text.trim()) continue;
    if (b.type === "URL" && !b.url.trim()) return "Un botón de tipo URL necesita una dirección.";
    if (b.type === "PHONE_NUMBER" && !b.phone.trim()) return "Un botón de teléfono necesita un número.";
  }
  return null;
}
